import React from 'react';
import { BsFillHeartFill } from "react-icons/bs";


export default function AllCargoSkeleton({ count = 8 }) {
    const items = Array.from({ length: count });

    return (
        <div className="w-full">
            <div className="grid gap-6 grid-cols-1 overflow-y-auto pb-5 min-h-full lg:h-[calc(100vh-10rem)] sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-3 animate-pulse">
                {items.map((_, idx) => (
                    <div key={idx} className="w-full">
                        <div className="rounded-[30px] transition duration-200 text-special w-full bg-white border-[1px] border-gray-300 h-max shadow-md flex flex-col justify-between items-center px-1 py-4">

                            {/* header */}
                            <div className="flex justify-between w-full h-max lg:px-8 px-5">
                                <div className="flex flex-row gap-4 items-center text-gray-900 w-auto">
                                    <div className="w-10 h-10 bg-gray-300 rounded-full" />
                                    <div className="h-5 w-20 bg-gray-300 rounded" />
                                </div>

                                <div className="flex flex-row gap-2 w-auto overflow-hidden items-center">
                                    <div className="text-center rounded-lg w-[80px] h-[20px] py-1 bg-gray-300" />
                                    <BsFillHeartFill className=" text-gray-300 text-lg" />                                </div>
                            </div>

                            {/* body */}
                            <div className="h-1/3 flex flex-col w-full justify-center items-center lg:py-7 py-4 lg:px-8 px-5">
                                <div className="flex flex-col items-start justify-center text-start w-full">
                                    <div className="h-4 w-3/4 bg-gray-300 rounded mb-2" />
                                    <div className="h-4 w-3/4 bg-gray-300 rounded mb-2" />
                                    <div className="h-4 w-2/4 bg-gray-300 rounded mb-2" />
                                </div>
                            </div>

                            <div className="w-full px-5">
                                <div className="w-full whitespace-nowrap lg:text-[16px] text-[14px] rounded-[12px] lg:1/4 h-[40px] bg-gray-300 text-center lg:px-10 py-2" />
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}
